// src/lib/analytics.js
// Google Analytics (GA4) helper for rypilpartner.
//
// The gtag library is loaded in public/index.html, but `gtag('config', ...)`
// is intentionally NOT called there. Config runs lazily the first time a
// trackable (non-Ops) page is viewed, so internal Ops-only sessions never
// activate the GA data stream.

const MEASUREMENT_ID = 'G-CLJEY2JCSN';

// Internal Ops pages live under /ops/* and must never be tracked.
export function isTrackablePath(pathname) {
  return !pathname.startsWith('/ops');
}

let configured = false;

function ensureConfigured() {
  if (configured) return;
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  // send_page_view:false — we send page_view manually so we control which
  // routes are tracked (and can exclude Ops).
  window.gtag('config', MEASUREMENT_ID, { send_page_view: false });
  configured = true;
}

// Sends a page_view for the given location, unless it's an internal Ops page.
export function trackPageView(pathname, search = '') {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  if (!isTrackablePath(pathname)) return;

  ensureConfigured();

  const page_path = pathname + search;
  window.gtag('event', 'page_view', {
    page_path,
    page_location: window.location.origin + page_path,
    page_title: document.title,
  });
}
